import useTranslation from 'next-translate/useTranslation'
import { StyledButton } from './NavButton'

interface NewCalculationButton {
  disabled?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const NewCalculationButton = ({
  disabled,
  onClick,
}: NewCalculationButton) => {
  const { t } = useTranslation('common')
  return (
    <StyledButton
      size='large'
      action='secondary'
      disabled={disabled}
      onClick={onClick}
    >
      {t('buttons.new')}
    </StyledButton>
  )
}
